var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboxDocs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2853 12.4287H15.2853C14.9064 12.4287 14.5431 12.5792 14.2751 12.8471C14.0072 13.115 13.8567 13.4784 13.8567 13.8573C13.8567 14.615 13.5557 15.3417 13.0199 15.8776C12.4841 16.4134 11.7573 16.7144 10.9996 16.7144C10.2418 16.7144 9.5151 16.4134 8.97928 15.8776C8.44345 15.3417 8.14244 14.615 8.14244 13.8573C8.14244 13.4784 7.99192 13.115 7.72402 12.8471C7.45611 12.5792 7.09275 12.4287 6.71387 12.4287H1.71387V18.8573C1.71387 19.2361 1.86438 19.5996 2.13229 19.8674C2.4002 20.1353 2.76355 20.2859 3.14244 20.2859H18.8567C19.2356 20.2859 19.599 20.1353 19.8669 19.8674C20.1347 19.5996 20.2853 19.2361 20.2853 18.8573V12.4287Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42773 6.71436L10.9992 10.2858L14.5706 6.71436",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.71436V10.2858",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxDocs);
export default __webpack_public_path__ + "static/media/inbox-docs.fcceecfd852464f9562e36c0bdcaa65e.svg";
export { ForwardRef as ReactComponent };